import React from "react";

/**
 * Renders sections of products grouped by category.
 *
 * Props:
 *  - groups: Array<{ categoryName, categoryLogo, products }>
 *  - renderProduct(product, index): cb returning a React node
 *  - showLogos: boolean (whether to render the inline category logo)
 */
const ProductsGridGrouped = ({ groups = [], renderProduct, showLogos = true }) => {
  if (!groups.length) return null;

  return (
    <>
      {groups.map((group) => (
        <section
          key={group.categoryName || "uncategorized"}
          className="pf-group"
        >
          <h2 className="pf-group-title">
            {group.categoryLogo && showLogos && (
              <img
                className="pf-group-title__logo"
                src={group.categoryLogo}
                alt=""
                aria-hidden="true"
              />
            )}
            <span>{group.categoryName}</span>
          </h2>
          <div className="pf-grid">
            {group.products.map((product, idx) =>
              renderProduct ? renderProduct(product, idx) : null
            )}
          </div>
        </section>
      ))}
    </>
  );
};

export default ProductsGridGrouped;
